import { render, staticRenderFns } from "./CompanyAwayEntitlementTable.vue?vue&type=template&id=51179600&scoped=true&"
import script from "./CompanyAwayEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./CompanyAwayEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51179600",
  null
  
)

export default component.exports